let itm = {
  bcg: require('../bcg_unit2.png'),
  animals: require('./bcg_anim_t.png'),
  name: 'Numbers and school objects',
  items: [
    {
      // disable: true,
      bcg: require('./bcg.png'),
      cssStyle: {
        position: 'absolute',
        top: '34.5%',
        left: '3.5%',
        height: '29.5%',
        width: '21.3%',
      },
      elem: [
        {
          bcg: require('./kp.png'),
          cssStyle: {
            position: 'absolute',
            top: '19.5%',
            left: '5%',
            height: '77%',
            width: '89%',
          },
          redirect: '6',
          type: 'page',
        },
      ],
    },
    {
      // disable: true,
      bcg: require('./bcg2.png'),
      cssStyle: {
        position: 'absolute',
        top: '34.5%',
        left: '27%',
        height: '29.5%',
        width: '21.3%',
      },
      elem: [
        {
          bcg: require('./v.png'),
          cssStyle: {
            position: 'absolute',
            top: '41%',
            left: '1.5%',
            height: '42%',
            width: '47.5%',
          },
          redirect: 'page000_game1',
          type: 'game',
        },
        {
          bcg: require('./s.png'),
          cssStyle: {
            position: 'absolute',
            top: '41%',
            left: '51%',
            height: '42%',
            width: '47.5%',
          },
          redirect: 'page001_game1',
          type: 'game',
        },
      ],
    },
    {
      // disable: true,
      bcg: require('./bcg3.png'),
      cssStyle: {
        position: 'absolute',
        top: '34.5%',
        left: '50.5%',
        height: '29.5%',
        width: '21.3%',
      },
      elem: [
        {
          bcg: require('./ko.png'),
          cssStyle: {
            position: 'absolute',
            top: '19%',
            left: '28%',
            height: '81%',
            width: '44%',
          },
          redirect: '0/u2',
          type: 'karta',
        },
      ],
    },
    {
      // disable: true,
      bcg: require('./bcg4.png'),
      cssStyle: {
        position: 'absolute',
        top: '26%',
        left: '74%',
        height: '55.5%',
        width: '21.3%',
      },
    },
  ],
};

export default itm;
